/**
 * Convert a markdown string to a .docx file and trigger a browser download.
 * Supports # / ## / ### headings, - bullet lists, and --- horizontal rules.
 */
export async function downloadAsDocx(markdownText, filename) {
  const { Document, Packer, Paragraph, TextRun, HeadingLevel } = await import('docx');
  const lines = markdownText.split('\n');
  const children = [];

  for (const line of lines) {
    if (line.startsWith('### ')) {
      children.push(new Paragraph({ text: line.slice(4), heading: HeadingLevel.HEADING_3 }));
    } else if (line.startsWith('## ')) {
      children.push(new Paragraph({ text: line.slice(3), heading: HeadingLevel.HEADING_2 }));
    } else if (line.startsWith('# ')) {
      children.push(new Paragraph({ text: line.slice(2), heading: HeadingLevel.HEADING_1 }));
    } else if (line.startsWith('- ') || line.startsWith('* ')) {
      children.push(new Paragraph({ text: line.slice(2), bullet: { level: 0 } }));
    } else if (line.trim() === '---') {
      children.push(new Paragraph({ text: '', border: { bottom: { style: 'single', size: 6 } } }));
    } else {
      children.push(new Paragraph({ children: [new TextRun(line)] }));
    }
  }

  const doc = new Document({ sections: [{ children }] });
  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
